<template>
    <Dashboard
        :title="__('Edit image', null, $page.props.profile_locale)"
    >
        <h2 class="border-b-2 text-xl border-gray-200 mb-4">{{__('Edit image', null, $page.props.profile_locale)}}</h2>
        <div>

            <div class="grid grid-cols-1 gap-3">
                <img :src="form.image ? form.image : image.url" class="w-20 mx-5"/>
                <InputLabel type="file" @update="createImage($event)" />
                <InputLabel
                    :label="__('Title', null, $page.props.profile_locale)"
                    v-model="form.name"
                    type="number"
                />
            </div>
            <Button
                padding="md"
                class="mt-5"
                @click="saveForm"
            >Zapisz</Button>
        </div>
    </Dashboard>
</template>

<script>
import Dashboard from '@/Layouts/Dashboard';
import SvgIcon from 'UI/SvgIcon';
import { ref } from '@vue/reactivity';
import InputLabel from 'UI/InputLabel';
import Button from 'UI/Button';

import { useForm } from '@inertiajs/inertia-vue3';


export default {
    components: { Dashboard, SvgIcon, InputLabel, Button },
    props: ['image'],

    setup(props) {
        const
            back = ref(false),
            form = useForm({
                image: null,
                name: props.image.name
            });

        const
            saveForm = () => {
                form.post(route('dashboard.engrave.pictogram.update', props.image.id), {
                    preserveScroll: true,
                })
            },
            createImage = (file, i, last) => {

                var reader = new FileReader();
                reader.onload = (e) => { form.image = e.target.result; };
                reader.readAsDataURL(file);
            };

        return {
            back,
            form,

            saveForm,
            createImage,
        }
    }
}
</script>

<style>

</style>
